<script setup>
const props = defineProps({
    maps: String,
});

const realMaps = props.maps.replace(/\\"/g, '"');
</script>

<template>
    <div class="container py-12 md:py-16">
        <div class="w-full max-w-full prose" v-html="realMaps"></div>
    </div>
</template>

<style>
iframe {
    width: 100%;
}
</style>
